<div class="main-content table-page table-page--compact table-page--dense asignacion-horario-page">
  <div class="container-fluid">
    <section class="table-page__hero">
      <div class="table-page__copy">
        <h1>Asignación de horarios</h1>
        <p>Elija el horario, revise quién lo tiene vigente y asigne colaboradores.</p>
      </div>
      <div class="table-page__toolbar-actions">
        <button type="button" mat-raised-button class="btn table-page__icon-btn table-page__icon-btn--secondary" (click)="regresar()">
          <span class="material-icons">arrow_back</span>
          Catálogo
        </button>
        <button type="button" mat-raised-button class="btn table-page__primary-btn" (click)="crearHorario()">
          <span class="material-icons">add_circle</span>
          Nuevo horario
        </button>
      </div>
    </section>

    <div class="row asignacion-horario-page__layout">
      <div class="col-12 col-xl-4">
        <section class="table-page__card">
          <form [formGroup]="form" class="asignacion-horario-page__form">
            <h2 class="asignacion-horario-page__titulo">Asignar colaborador</h2>

            <mat-form-field appearance="outline" class="table-page__field">
              <mat-label>Horario</mat-label>
              <mat-select formControlName="idHorarioLaboral">
                <mat-option *ngFor="let horario of horarios" [value]="horario.id">
                  {{ horario.nombre }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline" class="table-page__field">
              <mat-label>Colaborador</mat-label>
              <mat-select formControlName="idEmpleado">
                <mat-option>
                  <ngx-mat-select-search
                    [formControl]="empleadoFilterCtrl"
                    [placeholderLabel]="'Buscar colaborador'"
                    [noEntriesFoundLabel]="'No existe colaborador'">
                  </ngx-mat-select-search>
                </mat-option>
                <mat-option *ngFor="let empleado of empleadosFiltrados" [value]="empleado.idEmpleado">
                  {{ getEmpleadoNombre(empleado) }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline" class="table-page__field">
              <mat-label>Inicio de vigencia</mat-label>
              <input matInput [matDatepicker]="picker" formControlName="fechaInicioVigencia" aria-label="Inicio de vigencia" />
              <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>

            <div class="asignacion-horario-page__acciones">
              <button type="button" class="app-form-btn app-form-btn--primary app-form-btn--compact" [disabled]="saving" (click)="guardar()">
                <span class="material-icons">assignment_turned_in</span>
                {{ saving ? "Asignando..." : "Asignar horario" }}
              </button>
            </div>
          </form>
        </section>

        <section class="table-page__card" *ngIf="horarioSeleccionado">
          <div class="asignacion-horario-page__resumen">
            <div class="asignacion-horario-page__resumen-head">
              <h2 class="asignacion-horario-page__titulo">Horario seleccionado</h2>
              <span class="table-page__status-badge is-active" *ngIf="!loadingHorarioDetalle">
                {{ empleadosDelHorario.length }} colaboradores
              </span>
            </div>
            <div class="table-page__cell-stack">
              <strong class="table-page__name">{{ horarioSeleccionado.nombre || "Horario vigente" }}</strong>
              <span class="table-page__subtext">{{ horarioSeleccionado.descripcion || "Sin descripción" }}</span>
            </div>
            <p><strong>Semana:</strong> {{ getHorarioResumen() }}</p>
          </div>
        </section>

        <section class="table-page__card" *ngIf="jornadaActual">
          <div class="asignacion-horario-page__resumen">
            <h2 class="asignacion-horario-page__titulo">Jornada del colaborador</h2>
            <div class="table-page__cell-stack">
              <strong class="table-page__name">{{ jornadaActual.horarioLaboral?.nombre || "Horario vigente" }}</strong>
              <span class="table-page__subtext">
                {{ formatTime(jornadaActual.horaEntrada) }} - {{ formatTime(jornadaActual.horaSalida) }}
              </span>
            </div>
            <p><strong>Comida:</strong> {{ getJornadaComidas() }}</p>
            <p><strong>Objetivo diario:</strong> {{ jornadaActual.minutosLaboralesObjetivo || 0 }} min</p>
          </div>
        </section>
      </div>

      <div class="col-12 col-xl-8">
        <section class="table-page__card">
          <div class="table-page__toolbar asignacion-horario-page__panel-head">
            <h2 class="asignacion-horario-page__titulo">Colaboradores con este horario</h2>
          </div>

          <div class="table-page__table-wrap" *ngIf="empleadosDelHorario.length > 0; else empleadosHorarioEmptyState">
            <table class="table-page__table">
              <thead>
                <tr>
                  <th>Colaborador</th>
                  <th>Inicio</th>
                  <th>Fin</th>
                  <th>Estatus</th>
                  <th class="table-page__actions-head">Acción</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of empleadosDelHorario" [class.is-selected]="isSelectedEmpleado(item.empleado.idEmpleado)">
                  <td>
                    <div class="table-page__cell-stack">
                      <strong class="table-page__name">{{ getEmpleadoNombre(item.empleado) }}</strong>
                      <span class="table-page__subtext">{{ getEmpleadoBadge(item.empleado) }}</span>
                    </div>
                  </td>
                  <td><span class="table-page__text">{{ formatDate(item.asignacion.fechaInicioVigencia) }}</span></td>
                  <td><span class="table-page__text">{{ formatDate(item.asignacion.fechaFinVigencia) }}</span></td>
                  <td>
                    <span class="table-page__status-badge" [ngClass]="{ 'is-active': item.asignacion.estatus === 'ACTIVO', 'is-inactive': item.asignacion.estatus !== 'ACTIVO' }">
                      {{ item.asignacion.estatus || "-" }}
                    </span>
                  </td>
                  <td class="table-page__actions">
                    <button type="button" class="table-page__action-btn" title="Ver detalle" aria-label="Ver detalle"
                            (click)="seleccionarEmpleado(item.empleado.idEmpleado)">
                      <span class="material-icons">person_search</span>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <ng-template #empleadosHorarioEmptyState>
            <div class="table-page__empty" *ngIf="!loadingEmpleadosHorario; else empleadosHorarioLoadingState">
              <span class="material-icons">groups</span>
              <h3>No hay colaboradores vigentes</h3>
              <p>Seleccione un horario y una fecha para ver quién tiene activa esa plantilla.</p>
            </div>
          </ng-template>

          <ng-template #empleadosHorarioLoadingState>
            <div class="table-page__empty table-page__empty--loading">
              <span class="material-icons">hourglass_top</span>
              <h3>Revisando asignaciones</h3>
              <p>Espere un momento mientras se cruzan horarios y colaboradores.</p>
            </div>
          </ng-template>
        </section>

        <section class="table-page__card">
          <div class="table-page__toolbar asignacion-horario-page__panel-head">
            <h2 class="asignacion-horario-page__titulo">Historial del colaborador</h2>
          </div>

          <div class="table-page__table-wrap" *ngIf="asignacionesEmpleado.length > 0; else asignacionesEmptyState">
            <table class="table-page__table">
              <thead>
                <tr>
                  <th>Horario</th>
                  <th>Vigencia inicial</th>
                  <th>Vigencia final</th>
                  <th>Estatus</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let asignacion of asignacionesEmpleado">
                  <td>
                    <div class="table-page__cell-stack">
                      <strong class="table-page__name">{{ asignacion.horarioLaboral?.nombre || "-" }}</strong>
                      <span class="table-page__subtext">{{ asignacion.horarioLaboral?.descripcion || "Sin descripción" }}</span>
                    </div>
                  </td>
                  <td><span class="table-page__text">{{ formatDate(asignacion.fechaInicioVigencia) }}</span></td>
                  <td><span class="table-page__text">{{ formatDate(asignacion.fechaFinVigencia) }}</span></td>
                  <td>
                    <span class="table-page__status-badge" [ngClass]="{ 'is-active': asignacion.estatus === 'ACTIVO', 'is-inactive': asignacion.estatus !== 'ACTIVO' }">
                      {{ asignacion.estatus || "-" }}
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <ng-template #asignacionesEmptyState>
            <div class="table-page__empty">
              <span class="material-icons">event_busy</span>
              <h3>Sin historial visible</h3>
              <p>Seleccione un colaborador para revisar sus asignaciones y confirmar el cambio.</p>
            </div>
          </ng-template>
        </section>
      </div>
    </div>
  </div>
</div>
